import { useMemo, useState } from 'react';
import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import TrustBar from '@/pages/home/components/TrustBar';
import TopicWall from '@/pages/home/components/TopicWall';
import ArchiveSection from '@/pages/home/components/ArchiveSection';
import ResourceTypes from '@/pages/home/components/ResourceTypes';
import VerifyGuide from '@/pages/home/components/VerifyGuide';
import FaqSection from '@/pages/home/components/FaqSection';
import ComplianceSection from '@/pages/home/components/ComplianceSection';
import Footer from '@/pages/home/components/Footer';
import { homeArchiveItems, homeTopics } from '@/mocks/home';

export default function Home() {
  const [selectedTopic, setSelectedTopic] = useState('all');

  const topicName = useMemo(
    () => homeTopics.find((topic) => topic.id === selectedTopic)?.name ?? '全部素材',
    [selectedTopic],
  );

  const filteredItems = useMemo(() => {
    if (selectedTopic === 'all') {
      return homeArchiveItems;
    }
    const byTopic = homeArchiveItems.filter((item) => item.topicId === selectedTopic);
    if (byTopic.length > 0) {
      return byTopic;
    }
    return homeArchiveItems.filter((item) => item.labels.includes(topicName));
  }, [selectedTopic, topicName]);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <TopicWall topics={homeTopics} selected={selectedTopic} onSelect={setSelectedTopic} />
        <ArchiveSection items={filteredItems} topicName={topicName} />
        <ResourceTypes />
        <VerifyGuide />
        <FaqSection />
        <ComplianceSection />
      </main>
      <Footer />
    </div>
  );
}